import { RESET_DATASET } from 'store';

import { RESET_BOOTSTRAP_CIS } from '../types';
import { SET_SECONDARY_PARAMETER } from './types';

export default (state = null, action) => {
  switch (action.type) {
    case SET_SECONDARY_PARAMETER:
      return action.secondaryParameter;
    case RESET_DATASET:
    case RESET_BOOTSTRAP_CIS:
      return null;
    default:
      return state;
  }
};
